/** @jsxImportSource @emotion/react */
import { ComponentProps, FC } from 'react'
import { AttemptsAnalyticsChart } from '../AttemptsAnalyticsChart'
import { SpecificGameAnalytics } from '../SpecificGameAnalytics'
import { TotalStatistics } from '../TotalStatistics'
import * as classes from '../../styles'

type Props = {
  subjectId: string
  startDate?: string
  endDate?: string
  chartDataVariables: ComponentProps<typeof SpecificGameAnalytics>['chartDataVariables']
}

export const CARSGamesStatistics: FC<Props> = ({ subjectId, startDate, endDate, chartDataVariables }) => (
  <>
    <TotalStatistics subjectId={subjectId} startDate={startDate} endDate={endDate} />

    <div css={classes.chartsWrapper}>
      <SpecificGameAnalytics chartDataVariables={chartDataVariables} />

      <AttemptsAnalyticsChart subjectId={subjectId} />
    </div>
  </>
)
